import { createReducer } from 'utils/ReduxUtils';

import * as types from '../../../../actionTypes';

const initialState = null;

const setSelectedId = (_: unknown, { payload: auditModelId }: { payload: string }) => auditModelId;

const reset = () => initialState;

export default createReducer(initialState, {
  [types.DISPLAY_UNPUBLISH_MODAL]: setSelectedId,
  [types.HIDE_UNPUBLISH_MODAL]: reset,
  [types.PATCH_AUDIT_MODEL_STATUS_SUCCESS]: reset,
});
